import React from "react";
import { Box, Button, MenuItem, Select, Typography } from "@mui/material";
import MomentumChart from "./MomentumChart";

export default function ProgressDashboardCard({
  actionsCompleted7,
  consistencyPercent,
  helper,
  chartData,
  goalOptions = [],
  selectedGoalId = null,
  onSelectGoal,
  onOpenWeeklySummary,
}) {
  const selectedGoal = goalOptions.find((goal) => String(goal.id) === String(selectedGoalId)) || goalOptions[0] || null;

  return (
    <Box
      sx={{
        borderRadius: "20px",
        p: 1.55,
        background: "#ffffff",
        color: "#102033",
        boxShadow: "0 12px 26px rgba(15, 35, 59, 0.05)",
        border: "1px solid #dbe7f3",
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 1 }}>
        <Typography variant="h6" sx={{ fontWeight: 900, letterSpacing: 0, fontSize: "1.05rem" }}>
          Your progress
        </Typography>
        {onOpenWeeklySummary ? (
          <Button
            size="small"
            variant="text"
            onClick={onOpenWeeklySummary}
            sx={{
              minWidth: 0,
              px: 0,
              textTransform: "none",
              color: "#54667b",
              fontWeight: 750,
              fontSize: "0.8rem",
              "&:hover": {
                backgroundColor: "transparent",
                color: "#102033",
              },
            }}
          >
            This week
          </Button>
        ) : (
          <Typography variant="body2" sx={{ color: "#54667b", fontWeight: 700 }}>
            This week
          </Typography>
        )}
      </Box>

      <Typography variant="body2" sx={{ mt: 0.3, color: "#70839a", fontSize: "0.84rem" }}>
        {helper}
      </Typography>

      {selectedGoal ? (
        <Box sx={{ mt: 0.85 }}>
          <Typography variant="caption" sx={{ color: "#70839a", fontWeight: 760, fontSize: "0.68rem" }}>
            Goal
          </Typography>
          <Box sx={{ mt: 0.35 }}>
            <Select
              size="small"
              fullWidth
              value={selectedGoalId || selectedGoal.id}
              onChange={(event) => onSelectGoal?.(event.target.value)}
              sx={{
                borderRadius: "14px",
                bgcolor: "#f8fafc",
                border: "1px solid #dfe7ef",
                color: "#102033",
                fontWeight: 800,
                fontSize: "0.86rem",
                "& .MuiSelect-select": { py: 0.68, px: 1 },
                "& .MuiSvgIcon-root": { color: "#54667b" },
              }}
            >
              {goalOptions.map((goal) => (
                <MenuItem key={goal.id} value={goal.id}>
                  {goal.label}
                </MenuItem>
              ))}
            </Select>
          </Box>
        </Box>
      ) : null}

      <Box
        sx={{
          mt: 1,
          display: "grid",
          gridTemplateColumns: { xs: "1fr", sm: "repeat(2, minmax(0, 1fr))" },
          gap: 0.85,
        }}
      >
        <Box
          sx={{
            border: "1px solid #e7edf5",
            borderRadius: "14px",
            px: 0.95,
            py: 0.75,
            minWidth: 0,
          }}
        >
          <Typography variant="caption" sx={{ color: "#70839a", fontSize: "0.68rem" }}>
            Habits completed
          </Typography>
          <Typography variant="h5" sx={{ fontWeight: 850, mt: 0.15, fontSize: "1.15rem" }}>
            {actionsCompleted7}
          </Typography>
          <Typography variant="caption" sx={{ display: "block", mt: 0.25, color: "#70839a", fontSize: "0.68rem", letterSpacing: 0 }}>
            {actionsCompleted7 === 0 ? "No completed habits yet this week." : "Visible work logged this week."}
          </Typography>
        </Box>

        <Box
          sx={{
            border: "1px solid #e7edf5",
            borderRadius: "14px",
            px: 0.95,
            py: 0.75,
            minWidth: 0,
          }}
        >
          <Typography variant="caption" sx={{ color: "#70839a", fontSize: "0.68rem" }}>
            Active days
          </Typography>
          <Typography variant="h5" sx={{ fontWeight: 850, mt: 0.15, fontSize: "1.15rem" }}>
            {consistencyPercent}%
          </Typography>
          <Typography variant="caption" sx={{ display: "block", mt: 0.25, color: "#70839a", fontSize: "0.68rem", letterSpacing: 0 }}>
            Consistency means you showed up, even if habits are still open.
          </Typography>
        </Box>
      </Box>

      <Box sx={{ mt: 0.9 }}>
        <MomentumChart data={chartData} compact />
      </Box>
    </Box>
  );
}
